import { Component, OnInit, OnDestroy } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs/Observable';
import { Notification } from './notifications';
import { NotificationsService } from '../notifications/notifications.service';
import {Subscription} from 'rxjs/Subscription';


@Component({
  selector: 'mc-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {

  notifications = [];
  no = null;
  subscription: Subscription;

  constructor(private notificationsService: NotificationsService) { }

  ngOnInit() {

    this.notificationsService.getNotification().subscribe((notification: Notification) => {
      if (!notification) {
          this.notifications = [];
          return;
      }

      this.notifications.push(notification);
      this.no = this.notifications.length;
    });

    this.subscription = this.notificationsService.updatedNotification$
       .subscribe(item => this.update(item));
  }

  removeNotification(notification: Notification, $event) {
    this.notifications = this.notifications.filter(x => x !== notification);
    this.no = this.notifications.length;
    $event.stopPropagation();
  }

  removeAllNotifications() {
    this.notifications = [];
    this.no = this.notifications.length;
  }

  update(payload): void {
    const index = this.notifications.findIndex(x => x.id === payload.id);
    this.notifications[index] = payload;
    this.notifications = [...Array.from(new Set(this.notifications))];
    this.no = this.notifications.length;
  }

  trackByFn(index, item) {
    return index;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}






// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/template/notifications/notifications.component.ts